import { IResearchWorkItem } from "features/Research/types";
import { apiClient } from "lib/apiClient";

export interface ICancelResearchDemandRequest {
  demandId: string;
  version: number;
  reason: string;
}

export const cancelResearchDemand = async ({
  demandId,
  version,
  reason,
}: ICancelResearchDemandRequest): Promise<IResearchWorkItem> => {
  const response = await apiClient.post(
    `/research/demands/${demandId}/cancellation`,
    { version, reason }
  );

  return response.data;
};
